import { useModel, useRoute } from "@bcm-dev/bcms-vite";
import { useEffect } from 'react';

/**
 * @function ZelleIntegratedPage
 * @return {Void}
 * @exported true
 * @description A component used in MABI23 in order to immediately route
 * to different zelle pages determined by ABI22 branding.
 */
export default function ZelleIntegratedPage(props) {
  const options = useModel().branding.options;
  const hasMultiProfileOptionOn = options.multiprofile_abi22 === "true";
  const navigate = useRoute();

  // Immediately route after reading the zelle branding set.
  useEffect(() => {
    if(hasMultiProfileOptionOn) {
        navigate("/changeProfile");
    } else {
        navigate("/zelle");
    }
  });
}
